/**
 * Tab configuration for SimpleKeywordTabs
 */

import { LayoutGrid, Lightbulb, ListFilter, FileText, MessageSquare, TrendingUp, Link, Brain, Command } from 'lucide-react';
import { TabConfig } from '../types/keywordTabsTypes';

// Enhanced tab configuration matching workspace pattern
// Consolidated Keywords tab combines related, ideas, and suggestions like workspace
export const TAB_CONFIG: TabConfig[] = [
  { id: 'keywords', label: 'Keywords', icon: LayoutGrid, dataTypes: ['related_keywords', 'keyword_ideas', 'keyword_suggestions'] },
  { id: 'autocomplete', label: 'Autocomplete', icon: Command, dataType: 'autocomplete' },
  { id: 'subtopics', label: 'Subtopics', icon: FileText, dataType: 'subtopics' },
  { id: 'paa', label: 'People Also Ask', icon: MessageSquare, dataType: 'people_also_ask' },
  { id: 'trends', label: 'Google Trends', icon: TrendingUp, dataType: 'google_trends' },
  { id: 'serp', label: 'SERP', icon: Link, dataType: 'serp_analysis' },
];